import { useEffect, useState } from 'react';
import { supabase } from '../supabaseClient';

const DEBOUNCE_MS = 250;

const normalize = (s) => (s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().trim();

// Une ville identique à un pays (ex. "Italie") fait doublon avec la suggestion pays.
const dedupe = (items) => {
    const countryLabels = new Set(items.filter(i => i.kind === 'pays').map(i => normalize(i.label)));
    return items.filter(i => !(i.kind === 'ville' && countryLabels.has(normalize(i.label))));
};

export const useSearchSuggestions = (term) => {
    const [suggestions, setSuggestions] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const trimmed = term.trim();
        if (trimmed.length < 2) {
            setSuggestions([]);
            setLoading(false);
            return;
        }

        let cancelled = false;
        setLoading(true);
        const timer = setTimeout(() => {
            supabase.rpc('search_suggestions', { p_term: trimmed }).then(({ data, error }) => {
                if (cancelled) return;
                setSuggestions(!error && Array.isArray(data) ? dedupe(data) : []);
                setLoading(false);
            });
        }, DEBOUNCE_MS);

        return () => {
            cancelled = true;
            clearTimeout(timer);
        };
    }, [term]);

    return { suggestions, loading };
};
